import { Button } from '@material-ui/core';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import EmphasisIcon from './icon/EmphasisIcon';
import WithrawalIcon from './icon/WithrawalIcon';

const PopupRef = forwardRef(function Popup({}, ref) {
    const buttonRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [popupContent, setPopupContent] = useState('');
    const [onClickPositive, setOnClickPositive] = useState(null);
    const [onClickNegative, setOnClickNegative] = useState(null);
    const [hidePositive, setHidePositive] = useState(false);
    const [hideNegative, setHideNegative] = useState(false);
    const [positiveText, setPositiveText] = useState('확인');
    const [negativeText, setNegativeText] = useState('취소');
    const [positiveSymbol, setPositiveSymbol] = useState(false);
    const [negativeSymbol, setNegativeSymbol] = useState(false);

    useImperativeHandle(ref, () => ({
        openAll: (
            // content: 팝업에 보여줄 텍스트 내용 (<br/> 등 엘레먼트 테그 사용가능, ,<div> 테그 사용 불가)
            content,
            // onClickPositive: 확인버튼 눌렀을때 추가 동작 함수설정
            onClickPositive = null,
            // onClickNegative: 취소버튼 눌렀을때 추가 동작 함수설정
            onClickNegative = null,
            // hidePositive: 확인버튼 감추기 설정
            hidePositive = false,
            // hideNegative: 취소버튼 감추기 설정
            hideNegative = false,
            // positiveText: 확인버튼 텍스트 변경
            positiveText = '확인',
            // negativeText: 취소버튼 텍스트 변경
            negativeText = '취소',
            // positiveSymbol: 알림표시
            positiveSymbol = false,
            // negativeSymbol: 경고표시
            negativeSymbol = false,
        ) => {
            setOpen(true);
            content && setPopupContent(content);
            setOnClickPositive(onClickPositive);
            setOnClickNegative(onClickNegative);
            setHidePositive(hidePositive);
            setHideNegative(hideNegative);
            setPositiveText(positiveText);
            setNegativeText(negativeText);
            setPositiveSymbol(positiveSymbol);
            setNegativeSymbol(negativeSymbol);
            if (buttonRef != null && buttonRef.current != null && typeof buttonRef.current.focus === 'function')
                buttonRef.current.focus();
        },
        open: (content, onClick = null) => {
            setOpen(true);
            content && setPopupContent(content);
            setOnClickPositive(onClick);
            setOnClickNegative(null);
            setHidePositive(false);
            setHideNegative(false);
            setPositiveText('확인');
            setNegativeText('취소');
            setPositiveSymbol(false);
            setNegativeSymbol(false);
            if (buttonRef != null && buttonRef.current != null && typeof buttonRef.current.focus === 'function')
                buttonRef.current.focus();
        },
        openWarning: (content, onClick = null) => {
            setOpen(true);
            content && setPopupContent(content);
            setOnClickPositive(onClick);
            setOnClickNegative(null);
            setHidePositive(false);
            setHideNegative(false);
            setPositiveText('확인');
            setNegativeText('취소');
            setPositiveSymbol(false);
            setNegativeSymbol(true);
            if (buttonRef != null && buttonRef.current != null && typeof buttonRef.current.focus === 'function')
                buttonRef.current.focus();
        },
        openAlert: (content, onClick = null) => {
            setOpen(true);
            content && setPopupContent(content);
            setOnClickPositive(onClick);
            setOnClickNegative(null);
            setHidePositive(false);
            setHideNegative(true);
            setPositiveText('확인');
            setNegativeText('취소');
            setPositiveSymbol(false);
            setNegativeSymbol(true);
            if (buttonRef != null && buttonRef.current != null && typeof buttonRef.current.focus === 'function')
                buttonRef.current.focus();
        },
        openInfo: (content, onClick = null) => {
            setOpen(true);
            content && setPopupContent(content);
            setOnClickPositive(onClick);
            setOnClickNegative(null);
            setHidePositive(false);
            setHideNegative(true);
            setPositiveText('확인');
            setNegativeText('취소');
            setPositiveSymbol(true);
            setNegativeSymbol(false);
            if (buttonRef != null && buttonRef.current != null && typeof buttonRef.current.focus === 'function')
                buttonRef.current.focus();
        },
        openExtension: (content, onClickPositive, onClickNegative) => {
            setOpen(true);
            content && setPopupContent(content);
            setOnClickPositive(onClickPositive);
            setOnClickNegative(onClickNegative);
            setHidePositive(false);
            setHideNegative(false);
            setPositiveText('변경하기');
            setNegativeText('연장하기(3개월)');
            setPositiveSymbol(true);
            setNegativeSymbol(false);
            if (buttonRef != null && buttonRef.current != null && typeof buttonRef.current.focus === 'function')
                buttonRef.current.focus();
        },
    }));

    const handleOnClickPositive = () => {
        try {
            if (typeof onClickPositive == 'function') {
                onClickPositive();
            }
        } finally {
            setOpen(false);
        }
    };
    const handleOnClickNegative = () => {
        try {
            if (typeof onClickNegative == 'function') {
                onClickNegative();
            }
        } finally {
            setOpen(false);
        }
    };

    const onKeyDown = (e) => {
        if (e.key == 'Enter') {
            if (hideNegative) {
                handleOnClickPositive();
            } else if (hidePositive) {
                handleOnClickNegative();
            }
        }
    };

    if (open) {
        return (
            <>
                <div className='toast fade show'>
                    <div className='toast-icon'>
                        {negativeSymbol ? <WithrawalIcon /> : <></>}
                        {positiveSymbol ? <EmphasisIcon /> : <></>}
                    </div>
                    <div className='toast-body'>
                        <p className='txt-center'>{popupContent}</p>
                    </div>
                    <div className='toast-foot btn-wrap'>
                        {hideNegative ? (
                            <></>
                        ) : (
                            <Button
                                className='btn btn-popup negative'
                                variant='contained'
                                onClick={(e) => handleOnClickNegative(e)}
                                size='small'
                            >
                                {negativeText}
                            </Button>
                        )}
                        {hidePositive ? (
                            <></>
                        ) : (
                            <Button
                                ref={buttonRef}
                                className='btn btn-popup positive'
                                variant='contained'
                                onClick={(e) => handleOnClickPositive(e)}
                                onKeyDown={(e) => onKeyDown(e)}
                            >
                                {positiveText}
                            </Button>
                        )}
                    </div>
                </div>
                <div className='toast-back fade show'></div>
            </>
        );
    } else {
        return <></>;
    }
});

export default PopupRef;
